const firebaseConfig = {
    apiKey: "AIzaSyAyQWOJZZD5vlvSsVZqnhWPCrQvokVQOrc",
    authDomain: "drone-zilla.firebaseapp.com",
    projectId: "drone-zilla",
    storageBucket: "drone-zilla.appspot.com",
    messagingSenderId: "788289369482",
    appId: "1:788289369482:web:69b850d74a49a7f5c50473",
};
export default firebaseConfig;